import type { GlobalStylesProps } from "@mui/material/GlobalStyles";

const styles: GlobalStylesProps["styles"] = {
  html: {
    height: "100%",
  },
  /*
      Flexbox is needed to place the footer always at the bottom of the page
      whatever the height of the page is (but not in a fixed position)
    */
  "body, #root": {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "unset !important",
    fontSize: "16px",
  },
  // Hide the up/down arrow for input number
  "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
  },
  "input[type=number]": {
    MozAppearance: "textfield",
  },
};

export default styles;
